@for (agreement of agreements(); track $index) {
  <mpctm-contract-agreement [agreement]="agreement" />
}

@if (!agreements().length) {
  <p class="no-agreements-message">Es gibt keine Vereinbarungen</p>
}
